import { all, fork } from 'redux-saga/effects';

import listenLoad from './listenLoad';

export default function* rewardsPageSaga() {
  yield all([fork(listenLoad)]);
}
